import {isString, get, startCase, includes, keys, isEmpty, mapValues, random} from 'lodash'
import React from 'react'
import request from 'superagent'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import traverse from 'traverse'

import {kvReplace, getAuthToken, validUserLogin} from '../lib/utils'
import * as Actions from '../redux/actions'

const kvReplaceToken = ['{', '}']

// const toastr = require('toastr')

// toastr.options = {
//   "closeButton": false,
//   "debug": false,
//   "newestOnTop": false,
//   "progressBar": false,
//   "positionClass": "toast-top-center",
//   "preventDuplicates": false,
//   "onclick": null,
//   "showDuration": "300",
//   "hideDuration": "1000",
//   "timeOut": "5000",
//   "extendedTimeOut": "1000",
//   "showEasing": "swing",
//   "hideEasing": "linear",
//   "showMethod": "fadeIn",
//   "hideMethod": "fadeOut"
// }

class ActionButton extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      id      : this.props.id,
      schema  : this.props.schema,
      // title   : _t(get(this.props.schema, 'title')) || startCase(this.props.id),
      // classes : get(this.props.AXGClasses, ['action.button'], 'btn btn-default'),
      // classes : '',
      showMessage: false,
      toastr  : get(this.props.schema, 'toastr', {}),
      toastrMsg  : get(this.props.schema, 'toastr.default', ''),
      updates: get(this.props, 'schema.updates', ''),
    }
  }

  showToastr(msg) {
    console.log(`TODO: showToastr: ${msg}`)
    // if (msg) {
    //   toastr.info(msg)
    // }
  }

  handleActions(){
    let component = this
    let storeActions = component.props.actions
    component.setState({
      showMessage: true,
    })
    var actions = get(this, 'state.schema.actions', [])
    if (actions.length) {
      actions.forEach(
        (action) => {
          if (typeof action === 'object' && Object.keys(action)[0] === 'set-value') {
            let val = component.props.value
            Object.keys(val).forEach((k) => {
                storeActions.setAppxigonState({
                  // key: get(action, 'set-value.key'),
                  key: k,
                  value: val[k]
                })
              }
            )
          }
          if (typeof action === 'object' && Object.keys(action)[0] === 'close-modal') {
            storeActions.closeModal()
          }
          if (typeof action === 'object' && Object.keys(action)[0] === 'reset') {
            // TODO: reset options ?
            storeActions.resetInput()
          }
          if (typeof action === 'object' && Object.keys(action)[0] === 'link') {
            // TODO: condition
            let viewId = action['link']
            storeActions.setViewId({viewId: viewId})
          }
          if (typeof action === 'object' && Object.keys(action)[0] === 'modal') {
            let viewId = action['modal']
            let schema = get(this.props.appxigonSchema, `views.${viewId}`)
            // let schema = get(this.props.appxigonView, 'modalViewSchema')
            storeActions.setModalViewSchema({schema: schema})
          }
          if (typeof action === 'object' && Object.keys(action)[0] === 'call') {
            // console.log(`Action API Call: ${JSON.stringify(action)}`)
            storeActions.setLoadingState({loading:true})

            let callType = get(action, 'call.type', 'default')
            let callRequired = callType !== 'signout' ? true : false
            let callMethod = get(action, 'call.method', 'POST')
            let canCall = ['GET', 'POST', 'PUT', 'DELETE', 'HEAD', 'OPTIONS', 'CONNECT'].includes(callMethod)
            let endpoint = get(action, 'call.endpoint', '')
            let endpointTransform = get(action, 'call.transform')
            let postCallLink = get(action, 'call.link')
            let postCallAction = get(action, 'call.action')
            let callDelay = get(action, 'call.delay', 500)

            if (callType === 'signout') {
              storeActions.signOut()
            }

            // delay call to make sure stuff in redux store is actually ready
            setTimeout(function() {
              // start of ajax call construction
              if (callRequired && endpointTransform) {
                let keyMap = endpointTransform
                let keyMapTransformed =
                  mapValues(
                    keyMap,
                    (val)=> {
                      return get(component.props, ['appxigonState', `${val}`])
                    }
                  )
                // console.log(`keyMap: ${JSON.stringify(keyMap)}`)
                // console.log(`keyMapTransformed: ${JSON.stringify(keyMapTransformed)}`)
                endpoint = kvReplace(
                  endpoint,
                  keyMapTransformed,
                  kvReplaceToken
                )
              }
              console.info(`__ action.button:call: ${JSON.stringify(endpoint)}`)

              let dataMap = get(action, 'call.request-map', {})
              // TODO: generic transform handling. NO hard coding
              let integerTransform = get(action, 'call.request-transform.integer', [])
              // console.log(`Integer transforms: call: ${JSON.stringify(integerTransform)}`)
              let data = traverse(dataMap).map(
                function(node) {
                  let nodeKey = this.key
                  if (this.isLeaf) {
                    var retval = get(component.props.appxigonState, [node], '')
                    // console.log(`key: ${nodeKey} : ${retval}`)
                    if ( includes(integerTransform, nodeKey) ) {
                      console.log(`key: ${nodeKey} : ${retval}`)
                      retval = parseInt(retval)
                    }
                    this.update(retval)
                  }
                }
              )
              // console.log(`dataMap: ${JSON.stringify(dataMap)}`)
              console.log(`__ Request Data: ${JSON.stringify(data)}`)

              callRequired
              && canCall
              && request[callMethod.toLowerCase()](endpoint) // REVIEW: default endpoint ?
                .send(data)
                .set('Accept', 'application/json')
                .set('token', getAuthToken())
                .end((err, res) => {
                  if (res) {
                    // console.log(`Response: ${JSON.stringify(res.body)}`)
                    var responseMap = get(action, 'call.response-map', {})
                    // console.log(`Response Transform Map: ${JSON.stringify(responseMap)}`);
                    keys(responseMap)
                      .forEach((k)=> {
                        // TODO: add key-value-replace templating
                        storeActions.setAppxigonState({
                          key:  k,
                          value: res.body[responseMap[k]]
                        })
                      })
                    storeActions.setAppxigonState({
                      key   :  'api-error',
                      value :  '',
                    })
                    storeActions.setLoadingState({loading: false})
                    // component.showToastr(get(component.state, 'toastr.success'))
                    // call type == 'signin'
                    if (callType === 'signin') {
                      storeActions.signIn({
                        error: get(res.body, 'error'),
                        'error-description': get(res.body, 'errordescription'),
                        userid: get(res.body, 'email'),
                        token: get(res.body, 'token'),
                        'token-expiry': get(res.body, 'expiry')
                      })
                    }
                    // handles post call features
                    if (validUserLogin()) {
                      if (postCallLink) {
                        storeActions.setViewId({viewId: postCallLink})
                      }
                      if (postCallAction) {
                        let callFn = get(window, ['app', 'fn', postCallAction])
                        if (typeof callFn == 'function') {
                          callFn()
                        } else {
                          console.error(`AXG: ${postCallAction} is undefined or not a function`)
                        }
                      }
                    }
                  }
                  if (err) {
                    console.log(`Error: ${JSON.stringify(err)}`)
                    // component.showToastr(get(component.state, 'toastr.fail'))
                    storeActions.setAppxigonState({
                      key   :  'api-error',
                      value :  get(err,'responseJSON.error.details'),
                    })
                    storeActions.setLoadingState({loading:false})
                  }
                }) // end of ajax call
              },
              callDelay
            )
          } // end of 'call' action
        }
      )
    } else {
      var msg = 'No action to handle'
      console.log(msg)
      // component.showToastr(msg)
    }
    // setTimeout(function(){
    //   component.setState({
    //     showMessage: false,
    //   })
    // }, 1000);

    // updates dependent list
    // TODO: refactoring with other components
    let updates = component.state.updates
    if (updates) {
      if (isString(updates)) {
        updates = [updates]
      }
      console.log(`Update dependency for: ${JSON.stringify(updates)}`)
      updates.forEach((u)=> {
        component.props.actions.setAppxigonState({
          key : `dependency.${u}`,
          // make it a string. value not important, just for redux value change detection
          value: JSON.stringify(random(5, true)),
        })
      })
    }

  }

  componentWillReceiveProps(nextProps) {
    const p = this.props
    // REVIEW: is this a proper way ? Will this trigger unnecessary update?
    // REVIEW: also in select.ls
    var dependencyKey = `dependency.${this.props.AXGKey}`
    var nextDepencyValue = get(nextProps.appxigonState, dependencyKey, '')
    if (nextDepencyValue) {
      // quick hack to re-run actions of the button click
      // reset dependencyKey to null
      p.actions.setAppxigonState({
        key : dependencyKey,
        // make it a string. value not important, just for redux value change detection
        value: null,
      })

      this.handleActions()
    }
    this.setState({
      dependency: nextDepencyValue,
    })
  }

  render() {
    // console.log(`schema: ${JSON.stringify(this.state.schema)}`)
    // schema sample: {"type":"action.button","actions":["validate",{"link":"entities-info"}]}
    // link: -> link to another view
    // show / hide flag handled in parent component: Item
    const p = this.props
    let show = this.props.show
    let contextualClasses = get(this.state.schema, 'context', null)
    let localClasses = get(this.state.schema, 'classes')
    // let buttonClasses = get(this.state.scheme, 'button-classes')
    let faIcon = get(this.state.schema, 'fa-icon')
    let buttonClasses = get(this.state.schema, 'button-classes')
    let buttonClassNames = buttonClasses
      + ( contextualClasses ? ` btn-${contextualClasses}` : '' )
      + `${show ? '' : ' hidden'}`
      + `${buttonClasses ? ' ' + buttonClasses : ''}`
    let iconClasses = get(this.state.schema, 'icon-classes')
    const title = _t(get(p.schema, 'title')) || startCase(p.id)
    return (
      <div className={localClasses}>
        <button
          type='button'
          className={buttonClasses}
          onClick={this.handleActions.bind(this)}>
            {
              faIcon
              && <i className={`${faIcon} ${iconClasses}`}></i>
            }
            &nbsp;
            {
              !isEmpty(this.state.toastr) && this.state.showMessage
              ? this.state.toastrMsg
              : title
            }
        </button>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    appxigonState: state.AXGState,
    appxigonSchema: state.AXGSchema.schema,
    appxigonView: state.AXGView,
  }
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch)
  }
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ActionButton)



// WEBPACK FOOTER //
// ./item-types/action-button.js